const openSetVisibilityDialog = ids => ({
  type: 'GROUPS:SET_VISIBILITY_DIALOG:OPEN',
  ids
})

const closeSetVisibilityDialog = () => ({
  type: 'GROUPS:SET_VISIBILITY_DIALOG:CLOSE'
})

export { openSetVisibilityDialog, closeSetVisibilityDialog }
